// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular.json`.
import { NgxLoggerLevel } from 'ngx-logger';
import { VERSION } from './version';
import { AppEnvironment } from '@share/model-objects/environment.model';
import { AppEnvironmentName } from '@share/constants';

export const STAGING_API_URL = 'https://api-staging.eyefinity.com';
export const STAGING_DOMAIN_URL = 'https://cdn-pp-mt-stg.eyefinity.com';
export const STAGING_GATEWAY_CONTEXT = '/mt-pe-admin-api';
export const STAGING_S3_BUCKET = '/pe-conn-mt/';

export const environment: AppEnvironment = {
  production: false,
  envName: AppEnvironmentName.STG,
  loggingLevel: NgxLoggerLevel.DEBUG,
  dynatraceUrl:
    'https://js-cdn.dynatrace.com/jstag/147f273fa2a/bf63206omp/cb57db38c61e0a14_complete.js',
  serverLoggingLevel: NgxLoggerLevel.OFF,
  useDebugMode: false,
  version: VERSION,
  apiBasePath: STAGING_API_URL + STAGING_GATEWAY_CONTEXT,
  commandUrl: STAGING_API_URL + STAGING_GATEWAY_CONTEXT + '/command',
  oauthUrl: STAGING_API_URL + STAGING_GATEWAY_CONTEXT + '/oauth',
  queryUrl: STAGING_API_URL + STAGING_GATEWAY_CONTEXT + '/query',
  ssoUrl: STAGING_API_URL + STAGING_GATEWAY_CONTEXT + '/sso',
  mockDatabase: false,
  mockDataBaseApplication: 'eyefinity',
  baseDomain: STAGING_DOMAIN_URL,
  logoutUrl: STAGING_API_URL + '/idp/startSLO.ping',
  redirectUrl: STAGING_S3_BUCKET + 'index.html',
  baseHref: STAGING_S3_BUCKET,
  eosUrl: 'https://cdn-pp-mt-stg-eos.eyefinity.com/',
  encompassLogoutUrl: 'https://api-staging.eyefinity.com/ext/epm-logout',
  epmSignOnUrl:
    STAGING_API_URL +
    '/as/authorization.oauth2?' +
    'client_id=eye-ewebexpe&response_type=code' +
    '&scope=auth_epm+ef.pm_pe_office+ef.pm_pe_patient+ef.pm_pe_provider+ef.pm_pe_appointment+ef.pm_pe_order+read:ef.practice+ef.pm_pe_company+ef.pm_pe_office_recallreport+ef.pm_pe_staff' +
    '&un={{un}}&fun={{fun}}' +
    '&state={{state}}' +
    '&redirect_uri={{commandUrl}}/configureEpmIntegration',
};
